import {app} from '../app'

function asyncCopyFallback(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
  } else {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise((resolve, reject) => {
      document.execCommand('copy') ? resolve() : reject(new Error('Unable to copy to Clipboard.'))
      textArea.remove()
    })
  }
}

export function copyToClipboard(text, notice = null) {
  return asyncCopyFallback(text).then(
    () => {
      if (notice) {
        app.notify('Success', {type: 'success', text: notice})
      }
    },
    () => { /* do nothing */ }
  )
}

const onElementClick = function (event) {
  const el = event.currentTarget
  copyToClipboard(el.dataset.ctcText, el.dataset.ctcNotice)
}

const mounted = (el, binding) => {
  if (binding.value === false) {
    return
  }
  const notice = binding.arg === 'notice' && binding.value ? binding.value : el.dataset.ctcNotice
  const text = binding.arg === 'text' && binding.value ? binding.value : el.dataset.ctcText
  el.dataset.ctcNotice = notice || 'Text copied to clipboard'
  el.dataset.ctcText = text || el.innerText
  el.addEventListener('click', onElementClick)
}

const unmounted = (el) => {
  el.removeEventListener('click', onElementClick)
}

export default {
  mounted,
  unmounted
}
